<template>
  <div class="home">
    <div id="sources">
      <h3 style="text-align: center">Industry Level </h3>  

    
      <!-- Render each group -->
      <div
        v-for="(item, index) in dashboard"
        :key="index"
        class="row"
        :id="index"
      >
        <div class="col-md-12 title" @click="showClass(index)">
          📦Group {{ index + 1 }}: {{ item.group }}
        </div>

        <!-- Render each company card in the group -->
        <div
          v-for="(company, index) in item.companies"
          :key="index"
          class="col-md-4"
        >
          <CompanyCard
            v-if="!company.hide"
            :real_name="company.real_name"
            :nick_name="company.nick_name"
            :source="company.source"
          ></CompanyCard>
          <div v-if="company.hide" >
            
            <p style="text-center; padding: 20px;">
             <i> There are not enough amount of customer reviews for the topic {{ company.nick_name }}</i>
            </p>
          </div>
           
        </div>
      </div>

     
    </div>
    
    <IndustryBarChart :data="company_stats" metric="average_sentiment_score" desc="Average Sentiment Scores are calculated based on the average sentiment score of all the reviews of the company which ranges from -100 to 100. Since it is average, it is not affected by the number of reviews."/>

    <IndustryBarChart :data="company_stats" metric="number_of_reviews" desc="More reviews may reflect the more different point of view and the average sentiment score becomes more reliable."/>

    
    <IndustryBarChart :data="company_stats" metric="count_of_sentences" desc = "Peoples tend to type their review with fewer words. Thereofore, lengthy sentence numbers indicates the depth of the opinions." />
  </div>
</template>

<script>
// Import component named CompanyCard
import CompanyCard from "@/components/CompanyCard.vue";
import IndustryBarChart from '@/components/IndustryBarChart'

export default {
  name: "CompanyList",
  components: {
    CompanyCard,
    IndustryBarChart
  },
  data() {
    return {
      groups: [],
      dashboard: [],
      visible_groups: [],
      company_stats: []
    };
  },
  methods: {
    get_stats(){

     let active_group = this.dashboard
      let active_companies = active_group[0].companies.filter(x => x.hide != true)
      // console.log('--------------------')
      
      for(let i = 0; i < active_companies.length; i++){
   
        try{
          
        let company_data = require(`@/assets/analytics/${active_companies[i].source}/${active_companies[i].real_name}_dump.json`)
        let desc  = company_data.desc
        this.company_stats.push(desc)
        //console.log(JSON.stringify(desc))

        }
        catch(error){
          console.error("get_stats:", error);
        }
      }

    },

    fetchData() {
      try {
        this.dashboard = require("@/assets/dashboard.json"); // Adjust the file path
        // filter dashboard with group name parameter from router
        this.dashboard = this.dashboard.filter((x) => x.group === this.$route.params.groupname);
        this.groups = this.dashboard.map((x) => x.group);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    showClass(classNumber) {
      for (let i = 0; i < this.groups.length; i++) {
        this.visible_groups[i] = false;
      }
      // console.log(this.visible_groups);
      this.visible_groups[classNumber] = true;
    },
  },
  mounted() {
    this.fetchData();
    this.get_stats()
  },
};
</script>

<style scoped>
.row {
  border: solid 1px #65123b;
  margin-bottom: 10px;
  border-radius: 10px;
  padding-left: 10px;
}

.title {
  cursor: pointer;
}
</style>
